import config from 'config'
import { Redirect } from 'react-router-dom'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/my-office`,
    exact: true,
    component: () => (
      <Redirect to={`${publicPath}/my-office/detail`} />
    )
  },
  {
    path: `${publicPath}/my-office`,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        <Page.MyRegionOffice
          {...props}
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs {...props} params={get(props, 'match.params', {})} />
          }/>
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/my-office/detail`,
        exact: true,
        component: props => (
          <Page.MyRegionOfficeDetail {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/my-office/related-contacts`,
        exact: true,
        component: props => (
          <Page.MyRegionOfficeRelatedContacts {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/my-office/labels`,
        exact: true,
        component: props => (
            <Page.MyRegionOfficeLabels {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/my-office/logs`,
        exact: true,
        component: props => (
          <Page.MyRegionOfficeLogs {...props} params={get(props, 'match.params', {})} />
        )
      },
      {
        path: `${publicPath}/my-office/customizations`,
        exact: true,
        component: props => (
          <Page.MyRegionOfficeCustomizations {...props} params={get(props, 'match.params', {})} />
        ),
        isTypeId: ORGANIZATION_HIERARCHY.RO.id
      }
    ]
  }
]

export default routes
